const initialState = {
   
}
const StockReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default StockReducer;
